import React, { ChangeEvent, useState } from 'react';
import { CommentsOutsidePageEditor } from './CommentsOutsidePageEditor.component';

interface CommentsOutsidePageAddProps {
  rgzId?: string;
  handleSave: () => Promise<unknown>;
  canAddComment: boolean;
  isCommentOnCriterion: boolean;
  canAddCommentOnCriterion: boolean;
  canEditScore: boolean;
}

export const CommentsOutsidePageAdd: React.FC<CommentsOutsidePageAddProps> = ({
  rgzId,
  handleSave,
  canAddComment,
  isCommentOnCriterion,
  canAddCommentOnCriterion,
  canEditScore,
}) => {
  return (
    <CommentsOutsidePageEditor
      commentProp={''}
      onSave={handleSave}
      isActionVisible={false}
      rgzId={rgzId}
      commentId={''}
      canAddComment={canAddComment}
      isCommentOnCriterion={isCommentOnCriterion}
      canAddCommentOnCriterion={canAddCommentOnCriterion}
      canEditScore={canEditScore}
    />
  );
};
